import CardImage from './CardImage'

export default CardImage
